// sessionStorage key the Add Equipment page writes a newly created equipment id to, so the
// Resources step can auto-select it on return (the page goes back with navigate(-1), which
// can't carry state). Scoped by trip so it can never land on a different listing.
export const newEquipmentStorageKey = (tripId) => `wizard-new-equipment-${tripId}`
